
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'

export default new ApolloClient({
  // Provide the URL to the API server.
  link: new createHttpLink({ uri: '/graphql' }),
  // Using a cache for blazingly
  // fast subsequent queries.
  cache: new InMemoryCache(),
});